import tooltipPositions from "./constants/positions";
import BasicTooltip from "./basic";

export { BasicTooltip, tooltipPositions };
